export interface Seat {
  SeatId: number;
  Number: number;
  X: number;
  Y: number;
  Row: string;
  isAddtional: any;
  reserved: boolean;
  PriceAreaId: number;
  Sector: string;
  LogicalSector: string;
}

export interface Label {
  X: number;
  Y: number;
  Text: string;
  Width: any;
}

export interface Line {
  X1: number;
  Y1: number;

  X2: number;
  Y2: number;
}

export enum CanvasObjectType {
  LABEL = "LABEL",
  SEAT = "SEAT",
  LINE = "LINE",
}

interface CanvasObjectGeneric {
  type: CanvasObjectType;
}

export type CanvasObject = boolean;

export interface CanvasSeat extends CanvasObjectGeneric {
  type: CanvasObjectType.SEAT;
  data: Seat;
}

export interface CanvasLine extends CanvasObjectGeneric {
  type: CanvasObjectType.LINE;
  data: Line;
}

export interface CanvasLabel extends CanvasObjectGeneric {
  type: CanvasObjectType.LABEL;
  data: Label;
}

export enum TimeReservationAction {
  RESERVE = "RESERVE",
  UNRESERVE = "UNRESERVE",
}

export interface Price {
  PriceId: number;
  Name: string;
  Value: number;
  InternetPrice: number; // 0 - false 1 - true
  Hidden: number; // 0 - false 1 - true
  PriceAreaId: number;
  PriceTypeId: null;
  VatId: number;
}

export interface CartItem {
  SeatId: number;
  Row: string;
  Number: number;
  PriceAreaId: number;
  PriceValue: number;
  PriceId: number;
  PriceName: string;
  Sector: string;
  LogicalSector: string;
}

export interface Spectacle {
  SpectacleId: number;
  Program: string;
  Performers: string;
  Date: string;
  Statement: string;
  Code: any | null;
  UnnumberedSeats: boolean;
  VisibleAfterDeadline: boolean;
  PlayId: number;
  Cancelled: boolean;
  TicketPrintingId: any | null;
  Height: number;
  Width: number;
  AudienceId: number;
  DisplayName: string;
  Title: string;
  Author: string;
  Description: string;
  Adress: string;
  TitleWeb: string;
  DescribeWeb: string;
  Icon: string;
  Name: string;
  BOW: boolean;
}

export interface CreatePaymentDto {
  cart: CartItem[];
  payer: {
    email: string;
    firstName: string;
    lastName: string;
    phone: string;
    country: string;
    city: string;
    street: string;
    buildingNumber: string;
    postcode: string;
    region: string;
    //
    invoice: boolean;
    invoicePerson: boolean;
    invoiceCompany: string;
    invoiceNip: string;
    invoiceStreet: string;
    invoiceBuildingNumber: string;
    invoiceCity: string;
    invoicePostcode: string;
  };

  spectacleId: number;
  token: string;
}
